import { render, staticRenderFns } from "./sela.vue?vue&type=template&id=b8383544"
import script from "./sela.vue?vue&type=script&lang=js"
export * from "./sela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports